import React from "react";
import Box from "../box/Box";
import { COLORS, Typo } from "../../../../../layout/theme";
import {
	BiBox,
	BiDollar,
	BiCoinStack,
	BiPurchaseTag,
	BiTrash,
	BiCheckCircle,
	BiCheck,
} from "react-icons/bi";
import { MdSafetyDivider } from "react-icons/md";
import {
	BigChartContainer,
	Container,
	Dashboard1Container,
	DoubleChartContainer,
	FilterContainer,
	HeaderContainer,
} from "./styles";
import { Button, DatePicker, Select } from "antd";
import { numberWithDotAndCommas } from "../../../../../../utils/numberWithDotAndComas";
import { CONSTANTS } from "../../../../../../utils/constants";
import DebounceSelectSeller from "../../../../../common/debounce-select-seller/DebounceSelectSeller";
import CustomAntdTooltip from "../../../../../common/custom-antd-tooltip/CustomAntdTooltip";

export default function SaleDashboard({
	dashboard,
	optionsPie,
	timeSalesGraph,
	timeOrderGraph,
	timeUnitsGraph,
	distributors,
	selectDistributor,
	handleDateChange,
	deleteFilters,
	isLoading,
	selectedDistributor,
	rangeDate,
	selectOrdersInfo,
	ordersInfoSelector,
	selectDistributorsInfo,
	distributorsInfoSelector,
	optionsPie2,
	optionsPie3,
	selectedCategory,
	selectCategory,
	categories,
	selectedChain,
	selectChain,
	chains,
	userdata,
	sellers,
	selectSeller,
	selectedSeller,
	timeCategoriesSalesGraph,
	timeCategoriesUnitsGraph,
	categoryGraphSelector2,
	selectCategoryGraph2,
	timeHistoricSalesGraph,
	selectSalesInfo,
	salesInfoSelector,
	salesPeriod,
	selectSalesPeriod,
	handleApplyFilters,
}) {
	return (
		<Dashboard1Container>
			<FilterContainer>
				<Container
					style={{
						flexDirection: "row",
						alignItems: "end",
						justifyContent: "center",
						width: "140px",
					}}
				>
					<CustomAntdTooltip
						placement="top"
						width="110px"
						tooltipContent={[
							{
								title: `Aplicar filtros`,
							},
						]}
					>
						<Button
							type="primary"
							onClick={handleApplyFilters}
							icon={<BiCheck />}
							style={{
								borderRadius: 20,
								backgroundColor: COLORS.Success,
								borderColor: COLORS.Success,
							}}
						/>
					</CustomAntdTooltip>
					<CustomAntdTooltip
						placement="top"
						width="100px"
						tooltipContent={[
							{
								title: `Borrar filtros`,
							},
						]}
					>
						<Button
							type="danger"
							onClick={deleteFilters}
							icon={<BiTrash />}
							style={{ borderRadius: 20 }}
						/>
					</CustomAntdTooltip>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Fecha
					</Typo>
					{rangeDate ? (
						<DatePicker.RangePicker
							format="DD/MM/YYYY"
							value={rangeDate}
							onChange={(e) => handleDateChange(e)}
							disabled={salesPeriod === CONSTANTS.PERIOD_CURRENT}
						/>
					) : (
						<DatePicker.RangePicker
							format="DD/MM/YYYY"
							onChange={(e) => handleDateChange(e)}
							placeholder={["Desde", "Hasta"]}
							disabled={salesPeriod === CONSTANTS.PERIOD_CURRENT}
						/>
					)}
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Período
					</Typo>
					<Select
						showSearch
						//allowClear
						placeholder="Período"
						optionFilterProp="children"
						value={salesPeriod}
						onChange={(e) => selectSalesPeriod(e)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={CONSTANTS.MOBILE_DASHBOARD_PERIODS}
						style={{ width: 130 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Droguería
					</Typo>
					<Select
						showSearch
						// allowClear
						placeholder="Droguería"
						optionFilterProp="children"
						value={selectedDistributor}
						// defaultValue={selectedDistributor ?? null}
						onChange={(e, o) => selectDistributor(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={distributors}
						style={{ width: 150 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Cadena
					</Typo>
					<Select
						showSearch
						placeholder="Cadena"
						optionFilterProp="children"
						value={selectedChain}
						onChange={(e, o) => selectChain(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={chains}
						style={{ width: 120 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Categoria
					</Typo>
					<Select
						showSearch
						// allowClear
						placeholder="Categoria"
						optionFilterProp="children"
						value={selectedCategory}
						// defaultValue={selectedProvince ?? null}
						onChange={(e, o) => selectCategory(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={categories}
						style={{ width: 160 }}
					/>
				</Container>
				{!(!userdata.p_shop && userdata.p_mobile) && (
					<Container>
						<Typo type="primary" level={6}>
							Vendedor
						</Typo>
						<DebounceSelectSeller
							fetchCallback={sellers}
							placeholder="Vendedor"
							onValuesChange={selectSeller}
							initialValues={selectedSeller}
						/>
					</Container>
				)}
			</FilterContainer>
			<HeaderContainer>
				<Box
					data={numberWithDotAndCommas((dashboard?.totalYearSales).toFixed(0))}
					dataSuffix={"%"}
					secondData={(
						(dashboard?.salesWithOffer * 100) /
						dashboard?.totalYearSales
					).toFixed(2)}
					thirdData={(
						(dashboard?.salesWithoutOffer * 100) /
						dashboard?.totalYearSales
					).toFixed(2)}
					monthName={CONSTANTS.CALENDAR_MONTHS[dashboard?.actualMonth]}
					graphData={timeSalesGraph}
					isLoading={isLoading}
					type="headerBoxLaboratory"
					title={
						selectSalesInfo === "SALES" ? (
							<Typo texto="light" type="primary">
								Total ventas
							</Typo>
						) : selectSalesInfo === "UNITS" ? (
							<Typo texto="light" type="primary">
								Peso ventas
							</Typo>
						) : (
							""
						)
					}
					headerSubTitle2={"Mes Actual: "}
					selectSalesInfo={salesInfoSelector}
					salesInfo={selectSalesInfo}
					iconOption={<BiDollar size={20} />}
					iconOption2={<BiPurchaseTag size={20} />}
				/>
				{/* <Box
					data={
						ordersInfoSelector === "SALES"
							? dashboard?.totalOrders
							: dashboard?.totalYearUnits
					}
					subData={
						ordersInfoSelector === "SALES"
							? dashboard?.actualMonthOrders > 0
								? dashboard?.actualMonthOrders
								: null
							: dashboard?.unitsMonthInfo > 0
							? dashboard?.unitsMonthInfo
							: null
					}
					monthName={CONSTANTS.CALENDAR_MONTHS[dashboard?.actualMonth]}
					graphData={timeOrderGraph}
					secondGraphData={timeUnitsGraph}
					isLoading={isLoading}
					type="headerBoxSales"
					prefix={<BiBox />}
					selectOrdersInfo={selectOrdersInfo}
					ordersInfo={ordersInfoSelector}
					iconOption={<BiBox size={20} />}
					iconOption2={<BiCoinStack size={20} />}
					title={
						<Typo texto="light" type="primary">
							{ordersInfoSelector === "SALES"
								? "Total pedidos"
								: ordersInfoSelector === "UNITS"
								? "Total unidades"
								: ""}
						</Typo>
					}
				/> */}
				<Box
					data={dashboard?.totalYearUnits}
					subData={
						dashboard?.unitsMonthInfo > 0 ? dashboard?.unitsMonthInfo : null
					}
					monthName={CONSTANTS.CALENDAR_MONTHS[dashboard?.actualMonth]}
					graphData={timeUnitsGraph}
					isLoading={isLoading}
					type="headerBox"
					prefix={<BiBox />}
					title={
						<Typo texto="light" type="primary">
							Total unidades
						</Typo>
					}
				/>
				<Box
					data={dashboard?.totalOrders}
					subData={
						dashboard?.actualMonthOrders > 0
							? dashboard?.actualMonthOrders
							: null
					}
					monthName={CONSTANTS.CALENDAR_MONTHS[dashboard?.actualMonth]}
					graphData={timeOrderGraph}
					isLoading={isLoading}
					type="headerBox"
					prefix={<BiBox />}
					title={
						<Typo texto="light" type="primary">
							Total pedidos
						</Typo>
					}
				/>
			</HeaderContainer>
			<DoubleChartContainer>
				<Box
					graphData={timeHistoricSalesGraph}
					isLoading={isLoading}
					type="timeHeaderBox"
					title={
						<Typo texto="light" type="primary">
							Historico $/Un.
						</Typo>
					}
				/>
				<Box
					type="pieHeaderBoxSales"
					options={optionsPie}
					option2={optionsPie2}
					option3={optionsPie3}
					isLoading={isLoading}
					prefix={<MdSafetyDivider />}
					selectDistributorsInfo={selectDistributorsInfo}
					distributorsInfo={distributorsInfoSelector}
					iconOption={<BiDollar size={20} />}
					iconOption2={<BiBox size={20} />}
					iconOption3={<BiCoinStack size={20} />}
					title={
						<Typo texto="light" type="primary">
							{distributorsInfoSelector === "ORDERS"
								? "Droguerías: pedidos"
								: distributorsInfoSelector === "SALES"
								? "Droguerías: ventas"
								: distributorsInfoSelector === "UNITS"
								? "Droguerías: unidades"
								: ""}
						</Typo>
					}
				/>
			</DoubleChartContainer>
			<BigChartContainer>
				<Box
					type="timeChartMultipleCategories"
					options={timeCategoriesSalesGraph}
					iconOption={<BiDollar size={20} />}
					option2={timeCategoriesUnitsGraph}
					iconOption2={<BiCoinStack size={20} />}
					selectProductGraph={selectCategoryGraph2}
					productGraph={categoryGraphSelector2}
					isLoading={isLoading}
					title={
						<Typo texto="light" type="primary">
							{categoryGraphSelector2 === "SALES"
								? "Histórico ventas por categoría"
								: categoryGraphSelector2 === "UNITS"
								? "Histórico unidades por categoría"
								: ""}
						</Typo>
					}
				/>
			</BigChartContainer>
		</Dashboard1Container>
	);
}
